var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C16.7363 20 17.3333 19.403 17.3333 18.6667V12C17.3333 11.2636 16.7363 10.6667 16 10.6667C15.2636 10.6667 14.6666 11.2636 14.6666 12V18.6667C14.6666 19.403 15.2636 20 16 20Z",
    fill: "#C28A2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2317 23.3397L17.1584 7.41844C16.6469 6.52089 15.353 6.5209 14.8415 7.41844L5.76824 23.3397C5.26169 24.2286 5.9036 25.3332 6.92667 25.3332H25.0733C26.0964 25.3332 26.7383 24.2286 26.2317 23.3397ZM19.4752 6.0981C17.9407 3.40545 14.0592 3.40545 12.5247 6.0981L3.45139 22.0194C1.93173 24.686 3.85745 27.9999 6.92667 27.9999H25.0733C28.1425 27.9999 30.0682 24.686 28.5486 22.0194L19.4752 6.0981Z",
    fill: "#C28A2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 22.6668C17.3333 23.4032 16.7363 24.0002 16 24.0002C15.2636 24.0002 14.6666 23.4032 14.6666 22.6668C14.6666 21.9304 15.2636 21.3335 16 21.3335C16.7363 21.3335 17.3333 21.9304 17.3333 22.6668Z",
    fill: "#C28A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningToastIcon);
export default __webpack_public_path__ + "static/media/warning_toast_icon.2fbcd54d1c4056bdf0e4b92d129e1a1b.svg";
export { ForwardRef as ReactComponent };